import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { TrashIcon } from "../../../../ui/icons/trash";
import { ButtonComponent } from "../../../../ui/molecules/button/newButton";
import { Calendar } from "../../../../ui/molecules/calendar";
import { ProtocolSearch } from "../../../../ui/molecules/ProtocolSearch";
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static";
import TextArea from "../../../../ui/molecules/textArea";
import { Alert } from "../../../../ui/organisms/alert";
import { formatterDate, optionsFormatter, statoRichiestaComplianceRequest } from "../../../../utils";
import { ComplianceRequestsDeleteState, ComplianceRequestsState, ComplianceRequetsStatesValidation, resetComplianceRequestsStateValidationStatus, setStatusComplianceRequestId, setStatusDate, setStatusDepartureProtocol, setStatusEntryProtocol, setStatusNote, setStatusOfficer, setStatusRequest } from "../slice";

export function EditStateRequest() {
    const dispatch = useAppDispatch()
    const [showAlert, setShowAlert] = useState<boolean>(false)
    const complianceRequestState = useAppSelector(state => state.complianceRequest)
    const userState = useAppSelector(state => state.users)
    const [complianceRequestStateToDelete, setComplianceRequestStateToDelete] = useState<string | null>(null)

    useEffect(() => {
        dispatch(setStatusOfficer(userState.findMeResponse.id))
        dispatch(setStatusComplianceRequestId(complianceRequestState.complianceRequestId))
    }, [dispatch, userState.findMeResponse.id, complianceRequestState.complianceRequestId])

    useEffect(() => {
        if (complianceRequestState.complianceRequestsStateErrorsStatus === 'successfully') {
            dispatch(resetComplianceRequestsStateValidationStatus())
            dispatch(ComplianceRequestsState(complianceRequestState.ComplianceRequestStateCreation))
        }
    }, [complianceRequestState.complianceRequestsStateErrorsStatus])

    return (
        <div className="flex flex-col gap-4 w-full">
            <div className="text-left pb-1 text-md">
                <span className="font-semibold uppercase tracking-widest text-brandPrimary-600">Stati</span>
                <span className="px-2 font-semibold uppercase tracking-widest text-brandPrimary-300">/</span>
                <span className="font-semibold uppercase tracking-widest text-brandPrimary-800">Creazione</span>
            </div>
            <div className="border-b border-neutral-200 flex flex-col gap-5 pb-4">
                <MadfarmStaticSelect
                    label='Stato'
                    placeholder={'Seleziona Stato'}
                    error={complianceRequestState.complianceRequestsStateErrors.state}
                    value={complianceRequestState.ComplianceRequestStateCreation.state}
                    errorLabel='Selezionare uno stato'
                    options={statoRichiestaComplianceRequest}
                    onChange={(value) => {
                        //@ts-ignore
                        const newValue = value !== null ? value.value : null
                        dispatch(setStatusRequest(newValue))
                    }}
                    noOptionsMessage={""}
                />
                <Calendar
                    label="Data"
                    selected={complianceRequestState.ComplianceRequestStateCreation.date}
                    onClear={(date) => dispatch(setStatusDate(date))}
                    errorLabel={!complianceRequestState.ComplianceRequestStateCreation.date ? 'Seleziona una data valida' : undefined}
                    onChange={(date) => dispatch(setStatusDate(date))}
                />
                <ProtocolSearch
                    type='entry'
                    onSelect={(value) => { dispatch(setStatusEntryProtocol(value)) }}
                />
                <ProtocolSearch
                    type='departure'
                    onSelect={(value) => { dispatch(setStatusDepartureProtocol(value)) }}
                />
                <TextArea
                    label='Note'
                    onChangeText={(text) => { dispatch(setStatusNote(text)) }}
                    defaultValue={complianceRequestState.ComplianceRequestStateCreation.note}
                    value={complianceRequestState.ComplianceRequestStateCreation.note}
                />
                <div className="flex justify-end w-full">
                    <ButtonComponent
                        iconPosition="off"
                        variant="solid"
                        color="orange"
                        label="Aggiungi Stato"
                        size="sm"
                        onClick={() =>
                            dispatch(ComplianceRequetsStatesValidation(complianceRequestState.ComplianceRequestStateCreation))
                        }
                    />
                </div>
            </div>

            <div className="mt-4">
                {
                    complianceRequestState.complianceRequestStates?.map((requestState, index) => (
                        <div key={requestState.id ?? index} className="py-3">
                            <div className="state-box flex items-center justify-between gap-4">
                                <div className="flex-1">
                                    <div className="text-left">
                                        <span className="state-main">{optionsFormatter(requestState.state, statoRichiestaComplianceRequest)} - {formatterDate(requestState.date)}</span>
                                    </div>
                                    <div className="text-left">
                                        {
                                            requestState.entryProtocolInfo &&
                                            <span className="state-sub">{requestState.entryProtocolInfo} </span>
                                        }
                                        {
                                            requestState.departureProtocolInfo &&
                                            <span className="state-sub">
                                                {
                                                    requestState.entryProtocolInfo &&
                                                    <span className="state-sub"> -  </span>
                                                }
                                                {requestState.departureProtocolInfo}
                                            </span>
                                        }
                                    </div>
                                    <div className="text-left">
                                        <span className="state-note">{requestState.note}</span>
                                    </div>
                                </div>
                                <div className="flex items-center">
                                    <button className="p-3 border border-neutral-200 rounded-full flex justify-center items-center"
                                        onClick={() => {
                                            setComplianceRequestStateToDelete(requestState.id)
                                            setShowAlert(true)
                                        }}>
                                        <TrashIcon size={20} color="white" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))
                }
                {
                    (showAlert && complianceRequestStateToDelete) && (
                        <Alert title="Conferma operazione" close={() => setShowAlert(false)}>
                            <div className="flex flex-col justify-center">
                                <div className="pb-3">
                                    <div>
                                        Sei sicuro di voler eliminare la riga?
                                    </div>
                                </div>
                                <div className="mt-6 flex items-center justify-center">
                                    <ButtonComponent
                                        variant="outline"
                                        color="gray"
                                        iconPosition="off"
                                        label="Annulla"
                                        size="md"
                                        onClick={() => setShowAlert(false)}
                                    />
                                    <div className="pl-8">
                                        <ButtonComponent
                                            variant="solid"
                                            color="orange"
                                            iconPosition="off"
                                            label="Elimina"
                                            size="md"
                                            onClick={() => {
                                                dispatch(ComplianceRequestsDeleteState(complianceRequestStateToDelete))
                                                setShowAlert(false)
                                            }}
                                        />
                                    </div>
                                </div>

                            </div>
                        </Alert>
                    )
                }
            </div>
        </div>
    )
}